import { ApiContext, apiContextFetch } from "@/hooks/api/base"

interface AuthUriResponse {
  auth_uri: string
}

interface HubspotIntegrationStatus {
  connected: boolean
}

export function getHubspotAuthUri(context: ApiContext) {
  return apiContextFetch<AuthUriResponse>(context, "hubspot_integration/get_auth_uri")
}

export function fetchHubspotIntegration(context: ApiContext) {
  return apiContextFetch<HubspotIntegrationStatus>(context, "hubspot_integration")
}

export function deleteHubspotIntegration(context: ApiContext) {
  return apiContextFetch<void>(context, "hubspot_integration", {
    method: "DELETE",
  })
}
